'use strict';

angular.module('programme')

.controller('hyperlinkEditModalCtrl', function (
    $scope,
    $uibModalInstance
) {

    var init = function ()
    {
        $scope.hyperlink = {
            target: '_blank',
            href: '',
        };
    };

    $scope.ok = function ()
    {
        $uibModalInstance.close($scope.hyperlink);
    };

    $scope.cancel = function ()
    {
        $uibModalInstance.dismiss();
    };

    init();
});
